import { render } from "./deliverylist.vue?vue&type=template&id=f25dbc2c"
import script from "./deliverylist.vue?vue&type=script&lang=js"
export * from "./deliverylist.vue?vue&type=script&lang=js"

import "./deliverylist.vue?vue&type=style&index=0&id=f25dbc2c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__